import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useProcurerActions } from "../../../service/useProcurerActions";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, TextField, Typography } from "@mui/material";
import { CloseRounded } from "@mui/icons-material";
import ProcurerAccordionDetail from "./ProcurerAccordionDetail";
import { GlobalContext } from "../../../../../util/state/GlobalContextProvider";
import { useStatusValuesProcurer } from "../../../component/useStatusValuesProcurer";

interface ProcurerDetailModalProps {
    open: boolean,
    setOpen: Function,
    procurerId: string
}

const ProcurerDetailModal = ({ open, setOpen, procurerId }: ProcurerDetailModalProps) => {
    const { t } = useTranslation(['salesmarketing', 'translation']);
    const procurerActions = useProcurerActions();
    const { getStatusLabelProcurer } = useStatusValuesProcurer();
    const { globalData } = useContext(GlobalContext);
    const [detail, setDetail] = useState({
        tenantId: "",
        dealerId: "",
        genVendorCode: "",
        status: "",
        commercialCode: "",
        naming: "",
        bpCode: "",
        serviceType: "",
        country: "",
        region: "",
        city: "",
        address: "",
        streetNumber: "",
        postalCode: "",
        province: "",
        phoneNumber: "",
        cellPhoneNumber: "",
        email: "",
        area: "",
        finOldIdentificationCode: "",
        dms: "",
        agreementDate: "",
        repCompanyName: "",
        repVatNumber: "",
        siren: "",
        siret: "",
        representativeName: "",
        representativeEmail: "",
        representativeCellphone: "",
        taxCode: "",
        sdiCode: "",
        representativeContactName: "",
        representativeContactEmail: "",
        representativeContactCellphone: "",
        representativeIban: "",
        representativeAddress: "",
        representativeStreetNumber: "",
        representativePostalCode: "",
        representativeCity: "",
        representativeProvince: "",
        representativeHqCellphone: "",
        representativePec: "",
        oldCode: ""
    });

    const fetchDetail = async (procurerId: any) => {
        setDetail(await procurerActions.detailProcurer(procurerId));
    }

    useEffect(() => {
        if (open) {
            fetchDetail(procurerId);
        }
    }, [open])

    return (
        <>
            <Dialog open={open} maxWidth={false}>
                <DialogTitle>
                    <Grid container item xs={12}>
                        <Grid item xs={10}>
                            <Typography color="primary" className="ModalTitle">
                                {t('salesmarketing:procurer.detailModal.title')}
                            </Typography>
                        </Grid>
                        <Grid item xs={1}>
                            <IconButton sx={{ position: 'absolute', right: 16, top: 12, }} onClick={() => { setOpen(false) }}>
                                <CloseRounded />
                            </IconButton>
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent className="ProcurerDetailModalBody">
                    <Grid container spacing={2}>
                        {globalData?.user?.legalEntities?.length > 1 || globalData?.user?.dealers?.length > 1 ?
                            <Grid container item xs={12} spacing={1}>
                                {globalData?.user?.legalEntities?.length > 1 ?
                                    <Grid item xs={3}>
                                        <TextField
                                            fullWidth
                                            label={t('salesmarketing:legalEntityField')}
                                            value={detail?.tenantId}
                                            InputProps={{readOnly:true}}
                                        />
                                    </Grid> : null
                                }
                                {globalData?.user?.dealers?.length > 1 ?
                                    <Grid item xs={3}>
                                        <TextField
                                            fullWidth
                                            label={t('salesmarketing:dealerField')}
                                            value={detail?.dealerId}
                                            InputProps={{readOnly:true}}
                                        />
                                    </Grid> : null
                                }
                            </Grid> : null
                        }
                        <Grid container item xs={12} spacing={1}>
                            <Grid item xs={3}>
                                <TextField
                                    fullWidth
                                    label={t('salesmarketing:procurer.detailContent.companyNameField')}
                                    value={detail?.repCompanyName}
                                    InputProps={{readOnly:true}}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <TextField
                                    fullWidth
                                    label={t('salesmarketing:procurer.detailContent.vatNumberField')}
                                    value={detail?.repVatNumber}
                                    InputProps={{readOnly:true}}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <TextField
                                    fullWidth
                                    label={t('salesmarketing:procurer.detailContent.sirenField')}
                                    value={detail?.siren}
                                    InputProps={{readOnly:true}}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <TextField
                                    fullWidth
                                    label={t('salesmarketing:procurer.detailContent.siretField')}
                                    value={detail?.siret}
                                    InputProps={{readOnly:true}}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <TextField
                                    fullWidth
                                    label={t('salesmarketing:procurer.detailContent.vendorCodeField')}
                                    value={detail?.genVendorCode}
                                    InputProps={{readOnly:true}}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <TextField
                                    fullWidth
                                    label={t('salesmarketing:procurer.detailContent.bpCodeField')}
                                    value={detail?.bpCode}
                                    InputProps={{readOnly:true}}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <TextField
                                    fullWidth
                                    label={t('salesmarketing:procurer.detailContent.statusField')}
                                    value={getStatusLabelProcurer(detail?.status)}
                                    InputProps={{readOnly:true}}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <TextField
                                    fullWidth
                                    label={t('salesmarketing:procurer.detailContent.commercialCodeField')}
                                    value={detail?.commercialCode}
                                    InputProps={{readOnly:true}}
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <ProcurerAccordionDetail detail={detail} isDisabled={false} />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className="ModalFooter">
                    <Grid container rowSpacing={3} columnSpacing={3} sx={{paddingTop: "50px"}}>
                        <Grid container item xs={12} rowSpacing={1} columnSpacing={3}
                              justifyContent={"flex-end"}>
                            <Grid item>
                                <Button fullWidth size="small" color={"accent"} onClick={() => { setOpen(false) }}>
                                    {t('salesmarketing:procurer.buttons.close')}
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default ProcurerDetailModal;